<template>
  <div class="bg-white">
    <v-container fluid class="page__container--padding">
      <div class="container-sm mt-5">
        <!-- search -->
        <div class="d-flex justify-content-end">
          <search-input v-model="search" class="search-input" />
        </div>
        <!-- end search -->

        <v-data-table
          :headers="headers"
          :items="items"
          :footer-props="footerProps"
          :options="dataTableOptions"
          :mobile-breakpoint="null"
          :loading="loading"
          :search="search"
          class="elevation-2 table__desing-general table__alternating-rows--grey"
        >
          <template #[`item.SNAME`]="{ item }">
            <div class="text-left w-100 mx-auto table-link-container">
              <router-link
                class="font-weight-bold text-dark"
                :to="{
                  name: 'CreditAdvancePayment',
                  params: { KUNNR: item.KUNNR, VTWEG: item.VTWEG },
                }"
              >
                <span>{{ item.SNAME }}</span>
              </router-link>
            </div>
          </template>
        </v-data-table>
      </div>

      <confidentiality-notice class="my-3" />
    </v-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import axios from '@/plugins/axios';
  import ConfidentialityNotice from '@/components/ConfidentialityNotice';
  import SearchInput from '@/components/SearchInput.vue';

  export default {
    name: 'CreditCustomers',
    components: { ConfidentialityNotice, SearchInput },
    data() {
      return {
        headers: [
          { text: 'Cliente', value: 'KUNNR', align: 'center' },
          { text: 'Nombre', value: 'SNAME', align: 'center' },
        ],
        items: [],
        loading: false,
        search: '',
        footerProps: {
          itemsPerPageOptions: [10, 14, 24, 34, { text: 'Todas', value: -1 }],
          itemsPerPageText: 'Mostrar en grupo de:',
          showCurrentPage: false,
          pageText: 'Desplegado {0} / {1}',
        },
        dataTableOptions: {
          itemsPerPage: 14,
          pagination: {
            enabled: true,
            options: {
              numeric: true,
            },
          },
        },
      };
    },
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
    },
    mounted() {
      this.getCustomers();
    },
    methods: {
      async getCustomers() {
        try {
          const response = await axios.get('express-sales', {
            params: {
              VTWEG: this.user.VTWEG,
            },
            noCancelRequest: true,
            id: 'get-customers-' + parseInt(this.user.employee_number),
          });
          this.items = response.data.data;
        } catch (err) {
          this.$toast.error(
            'Ocurrió un error al obtener el listado de clientes'
          );
        }

        this.loading = false;
      },
    },
  };
</script>

<style scoped>
  .search-input {
    max-width: 250px;
  }
  .table-link-container {
    max-width: 500px;
  }
</style>
